// ---------------------------------------------------------------------------
// Digital Notice Board — icon catalog
// ---------------------------------------------------------------------------
// A curated, school-friendly set of icons. Elements store only the string key
// (e.g. "bell"); this map turns a key into a renderable react-icon component so
// nothing but plain JSON ever needs to be persisted.
// ---------------------------------------------------------------------------
import {
    FaBell,
    FaBookOpen,
    FaBullhorn,
    FaCalendarAlt,
    FaCheckCircle,
    FaClock,
    FaExclamationTriangle,
    FaFlag,
    FaFootballBall,
    FaGraduationCap,
    FaHeart,
    FaInfoCircle,
    FaMapMarkerAlt,
    FaMedal,
    FaMusic,
    FaPhoneAlt,
    FaSchool,
    FaStar,
    FaTrophy,
    FaUsers,
} from "react-icons/fa";

export const ICON_CATALOG = {
    school: {label: "School", Icon: FaSchool},
    cap: {label: "Graduation", Icon: FaGraduationCap},
    bell: {label: "Bell", Icon: FaBell},
    bullhorn: {label: "Announce", Icon: FaBullhorn},
    calendar: {label: "Calendar", Icon: FaCalendarAlt},
    clock: {label: "Clock", Icon: FaClock},
    book: {label: "Book", Icon: FaBookOpen},
    trophy: {label: "Trophy", Icon: FaTrophy},
    medal: {label: "Medal", Icon: FaMedal},
    star: {label: "Star", Icon: FaStar},
    flag: {label: "Flag", Icon: FaFlag},
    music: {label: "Music", Icon: FaMusic},
    sport: {label: "Sports", Icon: FaFootballBall},
    users: {label: "Students", Icon: FaUsers},
    heart: {label: "Heart", Icon: FaHeart},
    info: {label: "Info", Icon: FaInfoCircle},
    warning: {label: "Warning", Icon: FaExclamationTriangle},
    check: {label: "Success", Icon: FaCheckCircle},
    phone: {label: "Contact", Icon: FaPhoneAlt},
    location: {label: "Location", Icon: FaMapMarkerAlt},
};

// Fallback so a missing/renamed key never crashes the canvas.
export const resolveIcon = (key) => (ICON_CATALOG[key] || ICON_CATALOG.info).Icon;
